import { render, staticRenderFns } from "./RecentArticleList.vue?vue&type=template&id=3a913fe5"
import script from "./RecentArticleList.ts?vue&type=script&lang=ts&external"
export * from "./RecentArticleList.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports